import {default as timer, namespace as timerNamespace} from './modules/timer'
import {default as cart, namespace as cartNamespace} from './modules/cart'
import {default as pages, namespace as pageNamespace} from './modules/pages'
import createPersistedState from 'vuex-persistedstate'

const namespaced = true
const namespace = 'REUtils'

const modules = {
  [pageNamespace]: pages,
  [timerNamespace]: timer,
  [cartNamespace]: cart
}

// plugins
const plugins = [
  createPersistedState({
    paths: [
      `${namespace}.${timerNamespace}`,
      `${namespace}.${cartNamespace}`,
      `${namespace}.${pageNamespace}.showGlobalTimer`,
      `${namespace}.${pageNamespace}.savedLastRoute`,
      `${namespace}.${pageNamespace}.savedLastRouteData`,
    ],
    key: namespace,
  }),
]

export {namespaced, namespace, plugins, modules}


